import styled from "styled-components";

export const Semibold = styled.strong`
  font-weight: 600;
`;
